import type { RouteName } from '@maggie/core/router/types';

import type { SplitViewLayoutState } from './types';

export const initialSplitViewLayoutState: SplitViewLayoutState<RouteName> = {
  detail: undefined
};
